import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavParametrageComponent } from './nav-parametrage/nav-parametrage.component';

@NgModule({
	declarations: [NavParametrageComponent],
	imports: [RouterModule, CommonModule],
	exports: [NavParametrageComponent]
})
export class ParametrageModule {}
